module.exports = __webpack_public_path__ + "static/media/3.be067d0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Urolift/Images/3.png
// module id = 646
// module chunks = 0